import { type CommonAction, response } from "@iflyrpa/share";
import type { ActiomCommonParams } from "../../types";
import { Http } from "../../utils/http";
import { rid } from "../../utils/shipinhao/utils";

export interface GetShipinhaoBgmCategoryParams extends ActiomCommonParams {}

export interface BgmCategoryListResponse {
    errCode: number;
    errMsg: string;
    data: BgmCategoryDetail[];
}

export interface BgmCategoryDetail {
    items: {
        categoryId: string;
        categoryName: string;
    };
}

export type GetBgmCategoryAction = CommonAction<GetShipinhaoBgmCategoryParams, BgmCategoryDetail[]>;

export const getShipinhaoBgmCategory: GetBgmCategoryAction = async (_task, params) => {
    // 验证 extraParam 是否存在
    if (!params.extraParam) {
        return response(400, "缺少 extraParam 参数", []);
    }

    if (!params.extraParam.fingerPrintDeviceId || !params.extraParam.aId || !params.extraParam.uin) {
        return response(400, "fingerPrintDeviceId、aId和uin不能为空", []);
    }

    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://channels.weixin.qq.com/micro/content/post/finderNewLifeCreate",
        origin: "https://channels.weixin.qq.com",
        "content-type": "application/json",
        "finger-print-device-id": params.extraParam.fingerPrintDeviceId,
        "x-wechat-uin": params.extraParam.uin,
    };

    const http = new Http({
        headers,
    });

    const urlParams = new URLSearchParams({
        _aid: params.extraParam.aId,
        _rid: rid(),
        _pageUrl: "https://channels.weixin.qq.com/micro/content/post/finderNewLifeCreate",
    }).toString();

    const requestData = {
        timestamp: Date.now().toString(),
        _log_finder_uin: "",
        _log_finder_id: params.extraParam.finderUserName || "",
        rawKeyBuff: null,
        pluginSessionId: null,
        scene: 7,
        reqScene: 7,
    };

    const res = await http.api<BgmCategoryListResponse>({
        method: "post",
        url: `https://channels.weixin.qq.com/micro/content/cgi-bin/mmfinderassistant-bin/post/get_bgm_category_list?${urlParams}`,
        data: requestData,
    });

    const isSuccess = res?.errCode === 0;

    return response(isSuccess ? 0 : 414, res?.errMsg, res.data);
};
